(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[70968],{

/***/ 70968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ UberAccidentSection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/bestridesharelawyers/uberAccidentSection/style.module.scss
var style_module = __webpack_require__(46203);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/bestridesharelawyers/icons/LostEarningCapacity.tsx


function LostEarningCapacity() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "127",
        height: "115",
        fill: "none",
        viewBox: "0 0 127 115",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "#fff",
                strokeDasharray: "2 2",
                d: "M0.5 0.5H125.927V113.894H0.5z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M49.24 47.303a8.717 8.717 0 00-1.879-2.233 11.645 11.645 0 00-2.33-1.522 14.056 14.056 0 00-2.521-.949 21.195 21.195 0 00-2.449-.51 19.765 19.765 0 00-2.115-.21 42.357 42.357 0 00-1.529-.036v6.617l-12.466-9.05 12.466-9.023v5.846c1.523.068 2.875.28 4.052.632 1.178.351 2.21.791 3.094 1.32a10.689 10.689 0 012.273 1.781c.627.658 1.15 1.323 1.565 1.996.977 1.583 1.59 3.365 1.838 5.34zM78.38 47.303a8.697 8.697 0 011.879-2.232 11.647 11.647 0 012.33-1.523c.826-.402 1.667-.72 2.523-.948a21.116 21.116 0 012.449-.51 19.739 19.739 0 012.113-.21 42.748 42.748 0 011.53-.037v6.617l12.465-9.051-12.464-9.023v5.846c-1.524.068-2.875.28-4.053.632-1.177.35-2.21.791-3.093 1.32a10.676 10.676 0 00-2.273 1.78 12.117 12.117 0 00-1.564 1.997c-.981 1.584-1.596 3.367-1.842 5.342zM64.029 56.61c-4.752 0-8.624-3.872-8.624-8.625 0-4.771 3.87-8.64 8.624-8.64 4.78 0 8.64 3.865 8.64 8.64 0 4.757-3.861 8.625-8.64 8.625z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M82.536 85.577V72.016l4.981 13.561h8.28s-1.97-12.032-9.95-23.832c-4.05-5.564-11.545-7.027-16.177-4.023-.559.141-13.89 12.303-13.89 12.303l3.525-7.74a4.157 4.157 0 00-7.58-3.418l-8.917 19.785c-.79 1.75-.424 4.613 1.6 5.914 2.111 1.344 4.558.576 6.142-.671L60.773 75.7c-1.741 5.483-2.58 9.873-2.58 9.873h24.345l-.001.004z"
            })
        ]
    });
}
/* harmony default export */ var icons_LostEarningCapacity = (LostEarningCapacity);

;// CONCATENATED MODULE: ./src/components/bestridesharelawyers/icons/Counseling.tsx


function Counseling() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "127",
        height: "115",
        fill: "none",
        viewBox: "0 0 127 115",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "#fff",
                strokeDasharray: "2 2",
                d: "M0.5 0.5H125.927V113.894H0.5z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M51.111 68.898a1.831 1.831 0 00-1.274-.517H38.68V39.627a1.84 1.84 0 10-3.681 0v42.58a1.84 1.84 0 103.681 0V72.061h9.753v10.147a1.84 1.84 0 103.681 0v-11.68c0-.715-.41-1.326-1.004-1.63zM49.402 34.89a4.89 4.89 0 11-9.78-.001 4.89 4.89 0 019.78 0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M56.771 59.37h-8.324V56.16a4.028 4.028 0 002.997-.83 4.048 4.048 0 00.687-5.686l-3.696-4.712a4.414 4.414 0 00-8.821.267v18.59a4.418 4.418 0 004.418 4.418h8.324v11.353a4.418 4.418 0 008.835 0V63.788a4.42 4.42 0 00-4.42-4.417zM89.902 37.787a1.84 1.84 0 00-1.841 1.84V68.38H76.906a1.84 1.84 0 100 3.681H88.06v10.147a1.84 1.84 0 103.682 0V39.627c0-1.016-.824-1.841-1.84-1.841zM87.118 34.89a4.89 4.89 0 11-9.778 0 4.89 4.89 0 019.778 0z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M82.713 40.779a4.413 4.413 0 00-4.403 4.151l-3.697 4.712a4.048 4.048 0 003.684 6.515v3.212h-8.326a4.418 4.418 0 00-4.418 4.418v15.771a4.418 4.418 0 008.836 0V68.204h8.324a4.418 4.418 0 004.418-4.417v-18.59a4.42 4.42 0 00-4.418-4.418z"
            })
        ]
    });
}
/* harmony default export */ var icons_Counseling = (Counseling);

;// CONCATENATED MODULE: ./src/components/bestridesharelawyers/icons/MedicalBells.tsx


function MedicalBells() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "127",
        height: "115",
        fill: "none",
        viewBox: "0 0 127 115",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "#fff",
                strokeDasharray: "2 2",
                d: "M0.5 0.5H125.927V113.894H0.5z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                fillRule: "evenodd",
                d: "M82.22 34.318a3.94 3.94 0 00-1.15-2.781 3.94 3.94 0 00-2.782-1.151H46.83a3.932 3.932 0 00-3.932 3.932v43.256c0 1.489.841 2.85 2.173 3.517l5.005 2.503a3.941 3.941 0 003.517 0l5.232-2.617c.1-.05.218-.05.319 0l5.231 2.617a3.941 3.941 0 003.518 0l5.231-2.617c.1-.05.219-.05.319 0l3.087 1.544a3.933 3.933 0 005.69-3.517V34.318zM51.835 73.284h21.448a1.788 1.788 0 000-3.575H51.835a1.788 1.788 0 000 3.575zm0-7.15h21.448a1.788 1.788 0 000-3.575H51.835a1.788 1.788 0 000 3.575zm8.937-25.007a3.946 3.946 0 00-2.424 1.135 3.94 3.94 0 00-1.151 2.78v1.073a3.94 3.94 0 001.15 2.782 3.94 3.94 0 002.782 1.15h2.86c.095 0 .186.038.252.106a.353.353 0 01.105.252v1.073a.352.352 0 01-.105.252.353.353 0 01-.252.105h-5.005a1.788 1.788 0 000 3.575h1.788v1.787a1.788 1.788 0 003.574 0v-1.803a3.946 3.946 0 002.424-1.135 3.94 3.94 0 001.151-2.781v-1.073a3.94 3.94 0 00-1.15-2.78 3.94 3.94 0 00-2.782-1.152h-2.86a.353.353 0 01-.252-.105.353.353 0 01-.105-.253v-1.072c0-.094.037-.186.105-.252a.353.353 0 01.252-.105h5.005a1.788 1.788 0 000-3.575h-1.788v-1.788a1.788 1.788 0 00-3.574 0v1.804z",
                clipRule: "evenodd"
            })
        ]
    });
}
/* harmony default export */ var icons_MedicalBells = (MedicalBells);

;// CONCATENATED MODULE: ./src/components/bestridesharelawyers/icons/PainSuffering.tsx


function PainSuffering() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "127",
        height: "115",
        fill: "none",
        viewBox: "0 0 127 115",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "#fff",
                strokeDasharray: "2 2",
                d: "M0.823 0.5H126.25V113.894H0.823z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M87.116 53.95l-6.069-6.65a5.586 5.586 0 01-.772-1.516c-2.04-7.874-7.999-13.59-15.17-15.398l-3.42 7.232c-.055.175 0 .35.11.409l4.8 3.558a.32.32 0 01.055.466l-5.517 6.474c-.11.117-.11.292 0 .467l3.145 3.616c.11.117.11.292.055.409l-5.351 8.34c-.166.292-.607.117-.552-.233l1.434-7.466c0-.117 0-.233-.11-.291l-4.358-4.317a.375.375 0 01-.055-.408l3.696-6.008c.11-.175.055-.35-.11-.466l-5.075-3.558c-.11-.058-.166-.233-.11-.35l1.654-7.816c-10.591 2.741-17.432 13.824-15.39 25.314 1.048 5.95 4.413 11.432 8.88 15.048 2.98 2.45 4.69 6.299 4.524 10.323l-.11 2.8c-.055 1.05.717 1.866 1.71 1.866h17.652c.938 0 1.655-.758 1.71-1.75l.276-9.448 7.116-1.4c1.876-.35 3.145-2.275 2.758-4.316l-1.655-9.39 2.703-.526c2.262-.408 3.09-3.266 1.545-5.016z"
            })
        ]
    });
}
/* harmony default export */ var icons_PainSuffering = (PainSuffering);

;// CONCATENATED MODULE: ./src/components/bestridesharelawyers/uberAccidentSection/index.tsx






const uberAccidentList = [
    {
        title: "Medical Treatment",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_MedicalBells, {})
    },
    {
        title: "Counseling",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Counseling, {})
    },
    {
        title: "Pain & Suffering",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_PainSuffering, {})
    },
    {
        title: "Lost Time or Earnings",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_LostEarningCapacity, {})
    }, 
];
function UberAccidentSection() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: `${(style_module_default()).mainSection} flex flex-col   md:pl-28`,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "font-bold text-3xl leading-[45px] mt-20",
                children: "Uber & Lyft Sexual Assault Lawsuits"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-lg leading-8 mt-5 max-w-5xl",
                children: "Uber and Lyft have been scrutinized for inadequate safety protocols in their driver recruitment, particularly regarding background checks and in-person interviews, with concerns amplified regarding female passenger safety. These companies have faced accusations of neglecting passenger complaints, mishandling sensitive information, and reassigning reported drivers. To address these issues, lawyers are now aiding victims in reporting incidents, obtaining support, and pursuing legal action for appropriate compensation for the damages incurred. You could be eligible for compensation for any of the following:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col gap-10 sm:flex-row sm:flex-wrap lg:justify-center lg:gap-24 lg:max-w-5xl mt-12 mb-28",
                children: uberAccidentList.map((el, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-center ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "",
                                children: el.icon
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-lg leading-8 ",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "my-3 max-w-[160px] mx-auto text-center",
                                    children: el.title
                                })
                            })
                        ]
                    }, index))
            })
        ]
    });
}


/***/ }),

/***/ 46203:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","mainSection":"style_mainSection__l5JUA"};

/***/ })

}]);